import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment';
import adicionarItinerarioEmbarque from '../../actions/itinerario/adicionarItinerarioEmbarque'
import removerFiltroItinerarioEmbarque from '../../actions/itinerario/removerFiltroItinerarioEmbarque'
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscarEmbarquePassageiro extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isNome={this.props.isNome}
        isRadio={this.props.isRadio}
        isNumero={this.props.isNumero}
        isPorcentagem={this.props.isPorcentagem}
        isFiltroData={this.props.isFiltroData}
        adicionarFiltro={this.props.adicionarItinerarioEmbarque}
        removerFiltro={this.props.removerFiltroItinerarioEmbarque}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosItinerarioEmbarque
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarItinerarioEmbarque,
    removerFiltroItinerarioEmbarque,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscarEmbarquePassageiro)
